/**
 * Splide
 */

import Splide from '@splidejs/splide';

// MV
export function mvSplide() {
  document.addEventListener( 'DOMContentLoaded', function() {

    var splideElement = document.querySelector('.js-mv-slider .splide');

    if (splideElement) {
      var splide = new Splide( '.js-mv-slider .splide', {
        autoplay: true,
        type: "loop",
        pauseOnHover: true,
        pauseOnFocus: true,
        interval: 6000,
        speed: 800,
        // padding: "20%",
        gap: 0,
        perPage: 3,
        perMove: 1,
        breakpoints: {
          2000: {
            perPage: 2,
          },
          900: {
            perPage: 1,
          },
        }
      } );
      splide.mount();
    }
  });

}


// Works Thumbs
export function worksSplide() {
  document.addEventListener( 'DOMContentLoaded', function() {

    var mainElement = document.querySelector('.js-main-slider');

    if ( mainElement ) {
      var main = new Splide( '.js-main-slider', {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: true,
        autoplay: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        interval: 6000,
        speed: 800,
      } );
    }

    var thumbnails = document.getElementsByClassName("thumbnail");
    var current;

    for (var i = 0; i < thumbnails.length; i++) {
      initThumbnail(thumbnails[i], i);
    }

    function initThumbnail(thumbnail, index) {
      thumbnail.addEventListener("click", function () {
        main.go(index);
      });
    }

    main.on("mounted move", function () {
      var thumbnail = thumbnails[main.index];

      if (thumbnail) {
        if (current) {
          current.classList.remove("is-active");
        }

        thumbnail.classList.add("is-active");
        current = thumbnail;
      }
    });

    main.mount();

  });


  // document.addEventListener( 'DOMContentLoaded', function() {

  //   var mainElement = document.querySelector('.js-main-slider');
  //   var thumbnailElement = document.querySelector('.js-thumbnail-slider');

  //   if ( mainElement ) {
  //     var main = new Splide( '.js-main-slider', {
  //       type: "fade",
  //       rewind: true,
  //       pagination: false,
  //       arrows: true,
  //       autoplay: true,
  //       pauseOnHover: true,
  //       pauseOnFocus: true,
  //       interval: 6000,
  //       speed: 800,
  //     } );
  //   }

  //   if ( thumbnailElement ) {
  //     var thumbnails = new Splide( '.js-thumbnail-slider', {
  //       type: "loop",
  //       perPage: 3,
  //       pagination: false,
  //       isNavigation: true,
  //       focus: "center",
  //       arrows: false,
  //       gap: '8px',
  //     } );
  //   }

  //   main.sync(thumbnails);
  //   main.mount();
  //   thumbnails.mount();
  // });
}
